export type PrinterRole = 'main' | 'kitchen';

export interface PrinterInfo {
  id: string;
  name: string;
}

const PRINTER_STORAGE_KEY = 'KOT_PRINTER_CONFIG';
const PRINTER_LIST_STORAGE_KEY = 'KOT_PRINTER_LIST';
export const NO_PRINTER_ID = 'NO_PRINTER';
export const PAIR_ANOTHER_ID = 'PAIR_ANOTHER_PRINTER';

export const getSelectedPrinters = (): Partial<Record<PrinterRole, string>> => {
  try {
    const saved = localStorage.getItem(PRINTER_STORAGE_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
};

export const setSelectedPrinter = (role: PrinterRole, printerId?: string) => {
  const current = getSelectedPrinters();
  const next = { ...current, [role]: printerId };
  localStorage.setItem(PRINTER_STORAGE_KEY, JSON.stringify(next));
};

export const clearSelectedPrinters = () => {
  localStorage.removeItem(PRINTER_STORAGE_KEY);
};

export const getMainPrinterId = () => getSelectedPrinters().main;
export const getKitchenPrinterId = () => getSelectedPrinters().kitchen;

export const getPrinterList = (): PrinterInfo[] => {
  try {
    const saved = localStorage.getItem(PRINTER_LIST_STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch {
    return [];
  }
};

export const savePrinterList = (list: PrinterInfo[]) => {
  localStorage.setItem(PRINTER_LIST_STORAGE_KEY, JSON.stringify(list));
};

export const clearPrinterList = () => {
  localStorage.removeItem(PRINTER_LIST_STORAGE_KEY);
};

export const isPrinterConfigured = (role: PrinterRole): boolean => {
  const id = getSelectedPrinters()[role];
  return !!id && id !== NO_PRINTER_ID && id !== PAIR_ANOTHER_ID;
};

export const getPrinterById = (id?: string): PrinterInfo | undefined => {
  if (!id) return undefined;
  return getPrinterList().find(p => p.id === id);
};

export const ensureValidSelection = (printerId: string): boolean => {
  return printerId !== NO_PRINTER_ID && printerId !== PAIR_ANOTHER_ID;
};

export const PRINTER_KEYS = {
  PRINTER_STORAGE_KEY,
  PRINTER_LIST_STORAGE_KEY,
};


